import { useLocation } from 'react-router-dom'
import { MIN_SIDE, punktForSti, veksle } from '../../lib/meny'
import { useMenyvalgKontekst } from './menyvalgKontekst'

export function StjerneIkon({ fylt, className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" fill={fylt ? 'currentColor' : 'none'} aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
    </svg>
  )
}

/**
 * Stjerna ved sidetittelen (som i toppbaren i Amo Ctrl): legger siden i
 * Favoritter øverst i menyen, og er gul når den er der. Bare på sider som er
 * et menypunkt. Min side står alltid først i Favoritter og har ingen stjerne.
 * Under «Se som» vises den ikke, fordi den modusen bare er for lesing.
 */
export default function FavorittStjerne() {
  const meny = useMenyvalgKontekst()
  if (!meny?.aktiv || !meny.kanEndre) return null
  return <Stjerne meny={meny} />
}

function Stjerne({ meny }) {
  const { pathname } = useLocation()
  const punkt = punktForSti(meny.seksjoner, pathname)
  if (!punkt || punkt.path === MIN_SIDE) return null
  const er = meny.favoritter.includes(punkt.path)
  const tittel = er ? `Fjern ${punkt.label} fra favoritter` : `Legg ${punkt.label} i favoritter`
  return (
    <button
      type="button"
      onClick={() => meny.settFavoritter(f => veksle(f, punkt.path))}
      title={tittel}
      aria-label={tittel}
      aria-pressed={er}
      className={`self-center shrink-0 w-7 h-7 grid place-items-center rounded-md border transition-colors ${
        er ? 'text-accent border-accent/60 bg-accent/15' : 'text-text-muted border-border hover:text-text hover:bg-surface'
      }`}
    >
      <StjerneIkon fylt={er} className="w-3.5 h-3.5" />
    </button>
  )
}
